import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Subscription, interval, lastValueFrom } from 'rxjs';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { ResponseData } from 'src/app/helper/interface/response';
import { User } from 'src/app/helper/interface/user';
import { AuthService } from 'src/app/helper/service/auth.service';
import { SocketService } from 'src/app/layouts/default/service/socket.service';
import { UserApiService } from '../user/services/user-api.service';
import { PrintDocComponent } from 'src/app/shared/feature-modal/print-doc/print-doc.component';
import { ModalService } from 'src/app/shared/service/modal.service';
interface subChanges {
  data: any,
  type: 'TOKEN' | 'APPOINTMENT'
}

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  user: User = this.auth.currentUserValue;
  allToken: any = [];
  dashboardVariableChanges: Subject<subChanges> = new Subject<subChanges>();
  apiSub !: Subscription;
  constructor(private auth: AuthService, private http: HttpClient, private socketServe: SocketService, private userApi: UserApiService, private modalService: ModalService) {
    this.socketServe.socketEvent.subscribe(res => {
      switch (res.type) {
        case 'NEW_TOKEN':
          // update List of token
          this.newToken(res.data);
          break;
        case 'UPDATE_TOKEN':
          // update List of token
          this.updateTokenList(res.data);
          break;
      }
    })
    this.initSub();
  }
  initSub() {
    this.apiSub && this.apiSub.unsubscribe();
    this.apiSub = interval(6000).subscribe((val) => {
      //call every 5 sec
      // this.getAllTodaysToken();
    });
  }
  stopApiSub() {
    this.apiSub?.unsubscribe();
  }
  restartApiSub() {
    this.apiSub?.unsubscribe();
    this.initSub();
  }

  newToken(data) {
    if (data.docContent) {
      delete data.docContent;
    }
    this.allToken.push(data);
    this.restartApiSub();
    this.setVariableChanges({ data: this.allToken, type: 'TOKEN' });
  }

  updateTokenList(d: any) {
    const i = this.allToken.findIndex(a => a.token_no == d.token_no && a.counter_fk_id == d.counter_fk_id);
    if (i > -1) {
      this.allToken[i] = d;
      this.setVariableChanges({ data: this.allToken, type: 'TOKEN' })
    }
  }

  setVariableChanges(d: subChanges) {
    this.dashboardVariableChanges.next(d);
  }
  dataLoading = false
  getAllTodaysToken() {
    if (this.dataLoading) {
      return
    }
    this.dataLoading = true;
    const id: any = this.user.is_doctor ? this.user.user_id : 0;
    this.getTodayTokenApi(id).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.allToken = res.result;
        this.setVariableChanges({ data: res.result, type: 'TOKEN' })
      }
    })
      .finally(() => this.dataLoading = false)
  }

  getActiveTokenByCounterApi(id) {
    return lastValueFrom(this.http.get(`patient_visit/getActiveTokenByCounter/${id}`));
  }

  getTodayTokenApi(s: any = 0) {
    const id = this.user.is_doctor ? '/' + this.user.user_id : '';
    return lastValueFrom(this.http.get(`patient_visit/getTodaysToken${id}`));
  }
  updateTokenLocal(data) {
    this.allToken = [...this.allToken || [], ...[data]]
    this.setVariableChanges({ data: this.allToken, type: 'TOKEN' });
  }

  updateToken(id, status) {
    this.updateTokenStatusApi(id, status).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.updateTokenLocal(res.result);
      }
    })
  }
  markCompleteToken(id) {
    this.markCompleteApi(id).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.updateTokenLocal(res.result);
      }
    })
  }
  reCallToken(id) {
    this.reCallTokenApi(id).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.updateTokenLocal(res.result);
      }
    })
  }
  nextToken(counter_id) {
    this.callNextTokenApi(counter_id).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        if (res.result)
          this.allToken = [...this.allToken, ...[res.result]];
        this.setVariableChanges({ data: this.allToken, type: 'TOKEN' });
      }
    })
  }

  getToken(patient_fk_id, doctor_fk_id) {
    return new Promise((resolve) => {
      this.userApi.genToken(patient_fk_id, doctor_fk_id).then((a: ResponseData) => {
        if (a.statusCode == RESPONSE_CODE.SUCCESS) {
          // this.tokenNumber = a.result.token_no;
          this.printToken(a.result?.docContent);
          this.newToken(a.result)
          resolve(a.result)
          // this.dashboardService.getAllTodaysToken();
        }
      })
    })
  }

  printToken(content = '') {
    this.modalService.openModal(PrintDocComponent, { docContent: content }, 'modal-lg', 2)
  }

  callToken(data: any) {
    //this.socketServe.sendMessage('CALL_TOKEN', data, 'Call Token');
  }
  updateTokenStatusApi(id, status: any) {
    const s = { status: status }
    return lastValueFrom(this.http.post(`patient_visit/updateStatus/${id}`, s))
  }

  callNextTokenApi(counter_id) {
    return lastValueFrom(this.http.get(`patient_visit/callNexTokenByCounter/${counter_id}`))
  }
  reCallTokenApi(id) {
    return lastValueFrom(this.http.get(`patient_visit/reCallToken/${id}`))
  }
  markCompleteApi(id) {
    return lastValueFrom(this.http.get(`patient_visit/markComplete/${id}`))
  }
}